// extracted by mini-css-extract-plugin
export default {"container":"DraggableButton_container__gjzTy"};